import { SchemaItemGeneric } from "@rf/schemas/item-generic.shema";
import Yup, { array, number, string } from "@yup";
import { isWithinDominicanRepublic } from "@rf-l1/map-v2/helpers/bounds";
import { checkTypeProperty, enumKeyFormPropery } from "../helps";
import featureIndicators from "../../model/feature-indicators";
import { min } from "lodash";

const locationStepSchema = {
  // location
  owners_property: array()
    .label("Propietarios")
    .of(SchemaItemGeneric)
    .default([])
    .min(1, "Debe seleccionar al menos un propietario")
    .required("El propietario es requerido"),
  city_property: array()
    .label("Ciudad")
    .of(SchemaItemGeneric)
    .default([])
    .min(1, "Debe seleccionar una cuidad")
    .required("La ciudad es requerida"),
  sector_property: array()
    .label("Sector")
    .of(SchemaItemGeneric)
    .default([])
    .min(1, "Debe seleccionar un sector")
    .required("El sector es requerido"),
  address_property: string()
    .label("Dirección")
    .default("")
    .required("La dirección es requerida"),
  reference_point_property: string().label("Punto de referencia").default(""),
  position_property: array()
    .label("Posición")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.positions,
          projectTypeIds: featureIndicators.projectPositions
        }),
      then: (schema: any) =>
        schema
          .min(1, "Especifique la posición de la propiedad")
          .required("La posición es requerida"),
      otherwise: (schema: any) => schema
    }),

  longitude_property: Yup.isLngDo()
    .label("Longitud")
    .default("-70.48411161353349")
    .transform(value => (isNaN(value) ? undefined : value))
    .required("La longitud es requerida"),
  latitude_property: Yup.isLatDo()
    .label("Latitud")
    .default("19.049050125598214")
    .transform(value => (isNaN(value) ? undefined : value))
    .required("La latitude es requerida")
};

// Cross-field validation to ensure the coordinate pair is within the DR (excludes Haiti)
(locationStepSchema as any).longitude_property = (locationStepSchema as any).longitude_property.test(
  "rd-coordinate-pair",
  "La ubicación debe estar dentro de la República Dominicana",
  function (_lng) {
    const lat = Number((this.parent as any)?.latitude_property);
    const lng = Number((this.parent as any)?.longitude_property);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return true; // handled by required/numeric
    return isWithinDominicanRepublic(lat, lng);
  }
);

export default locationStepSchema;
export type ILocationPropertyStepSchema = typeof locationStepSchema;
export const CLocationPropertyStepSchemaKeys = Object.keys(locationStepSchema);
